module.exports = __webpack_public_path__ + "static/media/phone.ca2f60a3.svg";